import Route from 'rise-ui/utils/routing/route.js';

import strings from 'rise-ui/config/strings.js';
import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class TimeSeriesSelectionRoute extends Route {
  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Specify parameters and date ranges to query time series data '
            + 'from the Bureau of Reclamation on water, reservoir operations, water '
            + 'quality, hydropower, endangered and invasive species, and more at '
            + 'sub-hourly to annual intervals. Use custom or preset date ranges to '
            + 'get the data you need, from a single day to the whole period of record.',
        },
      },
    ];
  }

  @breadcrumb crumb = strings['time-series-selection-route'];
}
